<template>
  <component :is="as" :class="classes">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { cva, type VariantProps } from 'class-variance-authority';

const containerVariants = cva('mx-auto w-full px-4 md:px-6 lg:px-8', {
  variants: {
    narrow: {
      true: 'max-w-3xl',
      false: 'max-w-(--container-bafsy)',
    },
  },
  defaultVariants: {
    narrow: false,
  },
});

export type ContainerNarrow = NonNullable<VariantProps<typeof containerVariants>['narrow']>;

interface Props {
  as?: 'div' | 'section' | 'article' | 'header' | 'footer' | 'main' | 'nav';
  narrow?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  as: 'div',
  narrow: false,
});

const classes = computed(() => containerVariants({ narrow: props.narrow }));
</script>
